import { render, staticRenderFns } from "./mchDownload.vue?vue&type=template&id=16b096e2&scoped=true&"
import script from "./mchDownload.vue?vue&type=script&lang=js&"
export * from "./mchDownload.vue?vue&type=script&lang=js&"
import style0 from "./mchDownload.vue?vue&type=style&index=0&id=16b096e2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b096e2",
  null
  
)

export default component.exports